import { createContext } from "react";

import {
  defaultAlertDialogContext,
  AlertDialogContextModel,
} from "./alert-dialog-model.context.lib";

export const AlertDialogContext = createContext<AlertDialogContextModel>(defaultAlertDialogContext);
